/**
 * @file: ReservationDangerButton.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A solid danger button at the bottom of the reservation detail page — used for
 * the destructive cancel (in-play booking) and delete (cancelled booking)
 * actions; each confirms before acting.
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TouchableOpacity } from 'react-native';

export const ReservationDangerButton = memo(
  ({ label, onPress }: { label: string; onPress: () => void }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        activeOpacity={0.85}
        onPress={onPress}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          height: rpx(48),
          borderRadius: rpx(14),
          backgroundColor: LD.danger,
          marginTop: rpx(20),
        }}
      >
        <Typography.Text size={rpx(15)} color="#fff" bold>
          {label}
        </Typography.Text>
      </TouchableOpacity>
    );
  },
);
